<template>
  <div class="room-bg">
  	<div id="videost" class="videoBoxst" v-if="videoBoxs">
  		<div class="zzboxst">
  			<video  style="width:100%;height:100%" autoplay="autoplay" controls="controls" controlslist="nodownload"  :src="videomp4" ></video>
  		</div>
  		
  	</div>
  	<div id="dplayer" ref="player" class="dplayer" v-if="dplayers"></div>
    <div id="id_test_video" v-if="isShow"></div>    
    <div v-if="isTest || isPlay || !liveApplyInfo">
    	<div class="sxinbox">
    		<!-- 头部 start -->
        <room-header :showcoupon="showcoupon" :userInfo="userInfo" @attention="attention" :groupInfo="groupInfo" :ifLike="ifLike" :ownerInfo="ownerInfo" @coupon="coupon" @quitGroup="quitGroup"></room-header>
    	</div>	
      <div class="room-content">
        
        <!-- 头部 end -->
        <!-- 聊天室 start -->
        <chatroom v-if="isShow" class="chatroom" :message="messageQueen"></chatroom>
        <!-- 聊天室 end -->
        <!-- 底部 -->
        <room-bottom v-if="isShow" class="room-bottom" @send-message="sendMessage" :isTimReady="ifConnect" @like="like" @showGift="showGift" @showgoods="showgoods"></room-bottom>
        <!-- 底部 -->
        <!-- 礼物面板 start -->
        <gifts class="gifts" :style="animation?'bottom:0':''" @hideGift="hideGift" @sendgift="sendgift"></gifts>
        <!-- 礼物面板 end -->
        <!-- 商品面板 start -->
        <goods-list class="goodslist" :style="animation2?'bottom:0':''" @hidegoods="hidegoods" @buy="buy" :goods="goods"></goods-list>
        <!-- 商品面板 end -->
        <!-- 礼物以及动画 start -->
        <gift-animation v-if="hasgift" class="gift-animation" :avatar="giftAvatar" :nick="giftNick" @hideani="hideani"></gift-animation>
        <!-- 礼物以及动画 end -->
        <!-- 优惠券 -->
        <coupon class="coupon" v-if="hascoupon" :voucher="voucher" @hidecoupon="hidecoupon" @usecoupon="usecoupon"></coupon>
        <!-- 优惠券 -->
        <!-- 公告start -->
        <!-- <notice class="notice" :noticeText="noticeText" v-if="roomStatus!=='0'"></notice> -->
        <!-- 公告 end -->
      </div>
      <no-owner v-if="livenoing" :ownerInfo="ownerInfo"></no-owner>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js'
import DPlayer from 'dplayer'
import { MessageBox, Toast } from 'mint-ui'
import { mapState, mapActions } from 'vuex'
import roomHeader from './child/header'
import roomBottom from './child/bottom'
import chatroom from './child/chatroom'
import gifts from './child/gifts'
import coupon from './child/coupon'
import notice from './child/notice'
import goodsList from './child/goodslist'
import giftAnimation from './child/gift-animation'
import noOwner from './child/noowner'
import { loadScript,loadCSS } from '../../../util/common'
import { getLiveInfo, joinLive, leaveLive, addGift, addLike } from '../../../api/memberLive'
import { addInstantMessage } from '../../../api/memberInstantMessage'
import { receiveVoucher, getStoreVoucher } from '../../../api/homestoredetail'
import { addFavoriteStore, delFavoriteStore } from '../../../api/memberFavorite'
import { cartAdd } from '../../../api/homecart'
import { getWXConfigList,getresultWXConfig } from '../../../api/config'
var ws
export default {
  data () {
    return {
      isTest: this.$route.query.test ? 1 : 0,
      live_apply_id: 0,
      message: [],
      userInfo: {},
      groupInfo: {},
      ownerInfo: {},
      ifLike: false,
      animation: false,
      animation2: false,
      hasgift: false,
      giftAvatar: '',
      giftNick: '',
      showcoupon: false,
      hascoupon: false,
      voucherList: false,
      voucher: {},
      voucherIndex: 0,
      goods: [],
      livenoing:true,
      noticeText: '',
      liveApplyInfo: false,
      showChat: true,
      ifConnect: false,
      clientId: false,
      openLive: false,
      closeLive: false,
      isPlay: false,
      lockReconnect: false,
      timeOut: false,
      ifWait: false,
      isShow: true,
      dp: null,
      videomp4:'',
      videoBoxs:false,
      dplayers:true,
      video: {}
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      user: state => state.member.info
    }),
    messageQueen: function () {
      const queenLen = 100 // 内存里面放100条消息，以免观看直播太久撑爆内存
      if (this.message.length > queenLen) {
        const vl = this.message.length - queenLen
        for (let i = 0; i < vl; i++) {
          this.message.shift()
        }
      }
      return this.message
    }
  },
  components: {
    roomHeader,
    roomBottom,
    chatroom,
    gifts,
    coupon,
    notice,
    goodsList,
    giftAnimation,
    noOwner
  },
  created: function () {
  	this.noReloaded();
  	var openid=this.$route.query.openid;
    this.fetchConfig({})
    this.live_apply_id = this.$route.query.live_apply_id
    if (!this.live_apply_id) {
      Toast('Parameter error')
    }
    const { width, height } = window.screen
    getLiveInfo(this.live_apply_id).then(res => {
    	
    	//当huifang==1时---------回放视频
    	if(res.result.live_apply_info.huifang=="1"){
    		this.livenoing=false;
    		//是回放视频
    		var resvideo=res.result.live_apply_info;
    		if(resvideo.live_apply_video.indexOf(".mp4") !=-1){
    			this.videomp4=resvideo.live_apply_video;
    			this.videoBoxs=true;
    			this.dplayers=false;
    			this.isShow=false;
    		}else{
    			this.dplayers=true;
    			this.isShow=false;
    			this.video = {
			      //封面
			      img: "",
			      video: resvideo.live_apply_video,
			    }
			    this.loadVideo(this.video)
    		}
    	//当huifang不等于1时---------不是回放视频
    	}else{
    		//当前时间戳
				var currenttimes=Date.parse(new Date());	
				currenttimes=currenttimes/1000;	
				
				//当开播时间大于当前时间，并且推流（live_apply_push_state=0）-----预约状态
				if(res.result.live_apply_info.live_apply_play_time>currenttimes && res.result.live_apply_info.live_apply_push_state=="0"){
					if(res.result.live_apply_info.state==2){
    				this.iswxbottomShow=true;
						var tipsother = document.getElementById('tipsother');
							//判断是否在微信打开
					    var ua = navigator.userAgent.toLowerCase();
					    if (ua.match(/MicroMessenger/i) == "micromessenger") { 	
					        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
			            if (res.miniprogram) {
			            	//小程序打开    	          	            	
			            	tipsother.innerText = "The live broadcast has not started."
			            	this.Livedetails=true;
			            } else {
									//不是小程序打开
											tipsother.innerText = "The live has not started, please subscribe. You will be reminded if the live starts."
											    
			            }
					    } else {//不在微信打开
					    			tipsother.innerText = "The live broadcast has not started."
					    			this.Livedetails=true;
					    }
   						//判断是否在微信打开 end
						
		    	}else if(res.result.live_apply_info.state==3){
		    				//已订阅开播提醒
		    				this.isSubscribedShow=true;
								var tipsother = document.getElementById('tipsother');
								tipsother.innerText = "已订阅该直播开播提醒，该直播开播将会提醒您。"
		    	}else{
		    		
		    	}
		    //当结束时间大于当前时间，并且推流（live_apply_push_state=0）------正在直播
				}else if(res.result.live_apply_info.live_apply_end_time>currenttimes && res.result.live_apply_info.live_apply_push_state=="1"){
					//不是回放
		    		this.isShow = true;
		    		this.dplayers=false;
		    		this.liveApplyInfo = res.result.live_apply_info
			      getStoreVoucher(this.liveApplyInfo.live_apply_user_id).then(res => {
			      	
			        this.voucherList = res.result.voucher_list
			        if (this.voucherList.length) {
			          this.showcoupon = true
			        }
			      }).catch(error => {
			        Toast(error.message)
			      })
			      if (this.liveApplyInfo.goods_list) {
			        this.goods = this.liveApplyInfo.goods_list
			      }
			      this.groupInfo = {
			        groupID: this.liveApplyInfo.live_apply_id,
			        memberNum: res.result.online_info.online_count
			      }
			      this.ifLike = this.liveApplyInfo.is_favorate
			      this.ownerInfo = {
			        avatar: this.liveApplyInfo.live_apply_user_avatar,
			        nick: this.liveApplyInfo.live_apply_user_name,
			        fans: this.liveApplyInfo.live_apply_fans
			      }
			      this.openLive = true
			      if (this.liveApplyInfo.instant_message_url) {
			        this.createWebSocket()
			      }
			      var _this = this
			      
			      if(this.config.video_type=='aliyun'){
			      loadCSS('aliplayer','https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css')
			      loadScript('aliplayer', 'https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js', function () {
			        var player = new Aliplayer({
			          "id": "id_test_video",
			          "source": _this.liveApplyInfo.live_apply_play_url,
			          "width": width,
			          "height": height,
			          "autoplay": true,
			          "isLive": true,
			          "rePlay": false,
			          "playsinline": true,
			          "preload": true,
			          "controlBarVisibility": "hover",
			          "useH5Prism": true
			        }, function (player) {
			            player.play();
			            player.on('play',function(){
			            _this.isPlay = true;
			            _this.livenoing= false;
			            });
			            player.on('pause',function(){
			            _this.isPlay = false;
			            _this.livenoing= false;
			            });
			            player.on('liveStreamStop',function(){
			              MessageBox.confirm('', {
                message: 'The live has ended, would you like to see other live?',
                title: '',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
           }).then(action => {
			                _this.$router.push({ name: 'MemberLiveList' })
			              }).catch(error => {
			              })
			            });
			          }
			        );  
			      })
			      }else{
			      loadScript('TcPlayer', '//imgcache.qq.com/open/qcloud/video/vcplayer/TcPlayer-2.3.2.js', function () {
			        var player = new TcPlayer('id_test_video', {
			          'm3u8_hd': _this.liveApplyInfo.live_apply_play_url, // 请替换成实际可用的播放地址
			          // 'autoplay': true, // iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
			          'live': true,
			          'controls': 'system',
			          'systemFullscreen': true,
			          'width': width,
			          'height': height-100,
			          'x5_player': true,
			          'x5_type': 'h5',
			          'x5_fullscreen': 'true',
			          'listener': function (res) {
			            if (res.type == 'play') {
			              _this.isPlay = true;
			              _this.livenoing= false;
			            } else if (res.type == 'pause') {
			              _this.isPlay = false;
			              _this.livenoing= false;
			            } else if (res.type == 'error') {
				              MessageBox.confirm('', {
					                message: 'The live has ended, would you like to see other live?',
					                title: '',
					                confirmButtonText: 'Yes',
					                cancelButtonText: 'No'
					           }).then(action => {
							                _this.$router.push({ name: 'MemberLiveList' })
							              }).catch(error => {
							              })
			            }
			          }
			        })
			      })
			      }
			  //当结束时间小于当前时间，并且推流回放视频不等于空------回放    
				}else if(res.result.live_apply_info.live_apply_end_time<currenttimes && res.result.live_apply_info.live_apply_video!=""){

					this.livenoing=false;
	    		//是回放视频
	    		var resvideo=res.result.live_apply_info;
	    		if(resvideo.live_apply_video.indexOf(".mp4") !=-1){
	    			this.videomp4=resvideo.live_apply_video;
	    			this.videoBoxs=true;
	    			this.dplayers=false;
	    			this.isShow=false;
	    		}else{
	    			this.dplayers=true;
	    			this.isShow=false;
	    			this.video = {
				      //封面
				      //img: "https://cn.bing.com/th?id=OHR.MeotoIwa_ZH-CN3126370410_1920x1080.jpg&rf=LaDigue_1920x1080.jpg",
				      video: resvideo.live_apply_video,
				    }
				    this.loadVideo(this.video)
	    		}
				}else{
	
					//不是回放
		    		this.isShow = true;
		    		this.dplayers=false;
		    		this.liveApplyInfo = res.result.live_apply_info
			      getStoreVoucher(this.liveApplyInfo.live_apply_user_id).then(res => {
			      	
			        this.voucherList = res.result.voucher_list
			        if (this.voucherList.length) {
			          this.showcoupon = true
			        }
			      }).catch(error => {
			        Toast(error.message)
			      })
			      if (this.liveApplyInfo.goods_list) {
			        this.goods = this.liveApplyInfo.goods_list
			      }
			      this.groupInfo = {
			        groupID: this.liveApplyInfo.live_apply_id,
			        memberNum: res.result.online_info.online_count
			      }
			      this.ifLike = this.liveApplyInfo.is_favorate
			      this.ownerInfo = {
			        avatar: this.liveApplyInfo.live_apply_user_avatar,
			        nick: this.liveApplyInfo.live_apply_user_name,
			        fans: this.liveApplyInfo.live_apply_fans
			      }
			      this.openLive = true
			      if (this.liveApplyInfo.instant_message_url) {
			        this.createWebSocket()
			      }
			      var _this = this
			      
			      if(this.config.video_type=='aliyun'){
			      loadCSS('aliplayer','https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css')
			      loadScript('aliplayer', 'https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js', function () {
			        var player = new Aliplayer({
			          "id": "id_test_video",
			          "source": _this.liveApplyInfo.live_apply_play_url,
			          "width": width,
			          "height": height,
			          "autoplay": true,
			          "isLive": true,
			          "rePlay": false,
			          "playsinline": true,
			          "preload": true,
			          "controlBarVisibility": "hover",
			          "useH5Prism": true
			        }, function (player) {
			            player.play();
			            player.on('play',function(){
			            _this.isPlay = true;
			            _this.livenoing= false;
			            });
			            player.on('pause',function(){
			            _this.isPlay = false;
			            _this.livenoing= false;
			            });
			            player.on('liveStreamStop',function(){
			              MessageBox.confirm('', {
                message: 'The live has ended, would you like to see other live?',
                title: '',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
           }).then(action => {
			                _this.$router.push({ name: 'MemberLiveLists' })
			              }).catch(error => {
			              })
			            });
			          }
			        );  
			      })
			      }else{
			      loadScript('TcPlayer', '//imgcache.qq.com/open/qcloud/video/vcplayer/TcPlayer-2.3.2.js', function () {
			        var player = new TcPlayer('id_test_video', {
			          'm3u8_hd': _this.liveApplyInfo.live_apply_play_url, // 请替换成实际可用的播放地址
			          // 'autoplay': true, // iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
			          'live': true,
			          'controls': 'system',
			          'systemFullscreen': true,
			          'width': width,
			          'height': height-100,
			          'x5_player': true,
			          'x5_type': 'h5',
			          'x5_fullscreen': 'true',
			          'listener': function (res) {
			            if (res.type == 'play') {
			              _this.isPlay = true;
			              _this.livenoing= false;
			            } else if (res.type == 'pause') {
			              _this.isPlay = false;
			              _this.livenoing= false;
			            } else if (res.type == 'error') {
				              MessageBox.confirm('', {
					                message: 'The live has ended, would you like to see other live?',
					                title: '',
					                confirmButtonText: 'Yes',
					                cancelButtonText: 'No'
					           }).then(action => {
							                _this.$router.push({ name: 'MemberLiveLists' })
							              }).catch(error => {
							              })
			            }
			          }
			        })
			      })
			      }
				}
    	}

    	
    }).catch(error => {
    	this.dplayers=false;
      Toast(error.message)
    })
    
  },
	
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    loadVideo (videoInfo) {
      this.dp = new DPlayer({
        element: this.$refs.player,
        video: {
              pic: videoInfo.img, // 封面
          url: videoInfo.video,
          type: 'customHls',
          customType: {
            customHls: function (video, player) {
              const hls = new Hls()
              hls.loadSource(video.src)
              hls.attachMedia(video)
            }
          }
        }
      })
    },
    noReloaded: function () {
      if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        window.location.reload();
      }
    },
    hidecoupon () {
      this.hascoupon = false
    },
    usecoupon () {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      receiveVoucher(
        this.voucher.vouchertemplate_id
      ).then((res) => {
        this.voucherList.splice(this.voucherIndex, 1)
        if (!this.voucherList.length) {
          this.showcoupon = false
        }
        Toast(res.message)
        this.ifWait = false
      }).catch(function (error) {
        Toast(error.message)
        this.ifWait = false
      })
      this.hidecoupon()
    },
    coupon () {
      this.voucherIndex = Math.floor(Math.random() * this.voucherList.length) % this.voucherList.length
      this.voucher = this.voucherList[this.voucherIndex]
      this.hascoupon = true
    },

    buy (data) {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      cartAdd(data.goods_id, 1).then(
        res => {
          Toast(res.message)
          this.ifWait = false
        },
        error => {
          Toast(error.message)
          this.ifWait = false
        }
      )
    },
    hideani () {
      this.hasgift = false
      this.giftAvatar = ''
      this.giftNick = ''
    },
    showgoods () {
      this.animation2 = true
    },
    hidegoods () {
      this.animation2 = false
    },
    showGift () {
      this.animation = true
    },
    sendgift () {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      MessageBox.confirm('', {
                message: 'Confirm to send the gift?',
                title: '',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
           }).then(action => {
        addGift(this.liveApplyInfo.live_apply_id).then(res => {
          this.hideGift()
          this.ifWait = false
        }).catch(error => {
          Toast(error.message)
          this.ifWait = false
        })
      }).catch(error => {
      })
    },
    hideGift () {
      this.animation = false
    },
    like () {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      addLike(this.liveApplyInfo.live_apply_id).then(res => {
        this.ifWait = false
      }).catch(error => {
        this.ifWait = false
      })
    },
    attention () {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      if (!this.ifLike) {
        addFavoriteStore(this.liveApplyInfo.live_apply_user_id).then(
          response => {
            Toast(response.message)
            this.ifLike = !this.ifLike
            this.ifWait = false
          },
          error => {
            Toast(error.message)
            this.ifWait = false
          }
        )
      } else {
        delFavoriteStore(this.liveApplyInfo.live_apply_user_id).then(
          response => {
            Toast(response.message)
            this.ifLike = !this.ifLike
            this.ifWait = false
          },
          error => {
            Toast(error.message)
            this.ifWait = false
          }
        )
      }
    },
    quitGroup () {
      MessageBox.confirm('', {
                message: 'Do you confirm to exit?',
                title: '',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
           }).then(action => {
        if (this.openLive) {
          this.closeLive = true
        }
        if (this.clientId) {
          leaveLive(this.liveApplyInfo.live_apply_id, this.clientId).then(res => {
            this.$router.go(-2)
          }).catch(error => {
            Toast(error.message)
          })
        } else {
          this.$router.go(-2)
        }
      })
    },
    _getVarsByKey (arr, key) {
      var res
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].key === key) {
          res = arr[i].value
          break
        }
      }
      return res
    },
    toggleChat () {
      this.showChat = !this.showChat
    },
    sendMessage (data) {
      if (!this.ifConnect) {
        Toast('Chat system disconnected')
        return
      }
      if (!data) {
        Toast('Please enter chat content')
        return
      }
      addInstantMessage({
        to_id: this.liveApplyInfo.live_apply_id,
        to_type: 2,
        message: data,
        message_type: 0
      }).then(res => {
        Toast(res.message)
      }).catch(error => {
        Toast(error.message)
      })
    },
    goCloseLive () {
      MessageBox.confirm('', {
                message: 'Do you confirm to exit?',
                title: 'Exit reminder',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
           }).then(action => {
        if (this.openLive) {
          this.closeLive = true
        }
        if (this.clientId) {
          leaveLive(this.liveApplyInfo.live_apply_id, this.clientId).then(res => {
            this.$router.go(-1)
          }).catch(error => {
            Toast(error.message)
          })
        } else {
          this.$router.go(-1)
        }
      })
    },
    createWebSocket () {
      try {
        ws = new WebSocket(this.liveApplyInfo.instant_message_url)
        this.init()
      } catch (e) {
        this.reconnect()
      }
    },
    init () {
      ws.onopen = this.wsOpen
      ws.onmessage = this.wsMessage
      ws.onclose = this.wsClose
      ws.onerror = this.wsError
    },
    reconnect () {
      if (this.lockReconnect) {
        return
      };
      this.lockReconnect = true
      // 没连接上会一直重连，设置延迟避免请求过多
      this.timeOut && clearTimeout(this.timeOut)
      var _this = this
      this.timeOut = setTimeout(function () {
        _this.createWebSocket()
        _this.lockReconnect = false
      }, 4000)
    },
    wsOpen () {
      this.ifConnect = true
      // 心跳检测重置
      heartCheck.start()
    },
    wsMessage (res) {
      var message = JSON.parse(res.data)
      if (!message) {
        Toast('Fail to convert message: ' + res.data)
        return
      }
      var type = message.type || ''
      switch (type) {
        // Events.php中返回的init类型的消息，将client_id发给后台进行uid绑定
        case 'init':
          this.clientId = message.client_id

          joinLive(this.liveApplyInfo.live_apply_id, this.clientId).then(res => {

          }).catch(error => {
            Toast(error.message)
          })
          break
        case 'leave':
          this.groupInfo.memberNum = message.online_count
          break
        case 'join':
          this.groupInfo.memberNum = message.online_count
          break
        case 'gift':
          this.hasgift = true
          this.giftAvatar = message.member.member_avatar
          this.giftNick = message.member.member_name
          setTimeout(() => {
            this.hasgift = false
            this.giftAvatar = ''
            this.giftNick = ''
          }, 3000)
          break
        default:
          let msg = []
          msg.push({
            name: message.instant_message_from_name,
            message: message.instant_message,
            id: message.instant_message_id
          })
          this.message = this.message.concat(msg)
          this.$forceUpdate()
      }
      heartCheck.start()
    },
    wsClose (res) {
      this.ifConnect = false
      if (res.reason) {
        Toast('Chat system disconnected: ' + res.reason)
      }
      this.reconnect()
    },
    wsError (res) {
      Toast(res.errMsg)
      this.reconnect()
    }
  },
  mounted () {
//  this.loadVideo(this.video)
 },
  
}

// 心跳检测
var heartCheck = {
  timeout: 3000,
  timeoutObj: null,
  start: function () {
    var self = this
    this.timeoutObj && clearTimeout(this.timeoutObj)
    this.timeoutObj = setInterval(function () {
      // 这里发送一个心跳，后端收到后，返回一个心跳消息，
      ws.send('123456789')
    }, this.timeout)
  }
}

var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?16ad4c8fda52c167b8eba41062c801e6";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

</script>
<style scoped>
	.sxinbox{position: fixed;z-index: 999999;top: 0;left: 0;width: 100%;}
#dplayer{width: 100%;height: 100%;position: fixed;left: 0;top: 0;z-index: 99;}
.videoBoxst{position: fixed;width: 100%;height: 100%;top: 0;left: 0;z-index: 99;display: flex;background: #000;}
.videoBoxst div{display: none;}
.videoBoxst div.zzboxst{display: contents;width: 100%;}
  #id_test_video{position: fixed;top:0;bottom:0;left:0;right:0;}
  .room-bg {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    position: relative;
  }
  .bg-img {
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .room-content {
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .room-bottom {
    position: absolute;
    bottom: 0;
    width: 100vw;
    height: 2.5rem;
    margin-bottom: constant(safe-area-inset-bottom);
    /* 兼容 iOS < 11.2 */
    margin-bottom: env(safe-area-inset-bottom);
    /* 兼容 iOS >= 11.2 */
  }
  .chatroom {
    width: 70vw;
    max-height: 30vh;
    position: absolute;
    bottom: 6rem;
    overflow: auto;
    box-sizing: border-box;
    z-index: 100;
    padding: 0.4640625rem;
  }
  .gifts,
  .goodslist {
    position: absolute;
    width: 100vw;
    height: 45vh;
    background-color: #fff;
    bottom: -45vh;
    z-index: 800;
    left: 0;
    transition: bottom 0.2s;
  }
  .gift-animation {
    position: absolute;
    top: 30vh;
    left: 0.421875rem;
  }
  .coupon {
    margin-top: 8.4375rem;
  }
  .live-player {
    width: 100vh;
    height: 100vw;
    background-color: #fff;
  }
  .notice {
    position: absolute;
    left: 0.421875rem;
    bottom: 50vh;
    max-width: 60vw;
  }
  .dplayer-mobile-play{z-index: 999;}
</style>
